import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
// import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString, transformRequest } from '../../utils/API/requestMiddleware';
// import { encryptUrlData } from '../../services/CryptoService';

const linkupRequestAPI = createApi({
    baseQuery: defautBaseQuery,
    reducerPath: 'linkupRequestAPI',
    endpoints: (builder) => ({

        getAllLinkupRequest: builder.query({
            query: function (params) {
                const { url } = params;
                
                let { first, rows, sortField, sortOrder, openStatus, search, ...retVal } = params.params;

                retVal.Pagination = {
                    PageNumber: (first / rows) + 1,
                    PageSize: rows
                };
                retVal.filters = { searchText: search };
                retVal.sortString = '';
                // retVal.pageIndex = (first / rows);
                // retVal.pageSize = rows;

                if (sortField) {
                    retVal.sortField = sortField;
                    retVal.sortDesc = sortOrder < 0;
                }
                if (openStatus) {
                    retVal.openStatus = openStatus
                }

                return {
                    url: params.url,
                    params: { getAllLinkupRequest: JSON.stringify(retVal) }
                };
            },
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        addLinkupRequest: builder.mutation({
            query: (requestData) => ({
                url: '/Linkup/AddLinkupRequest',
                method: 'POST',
                body: transformRequest(requestData)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getLinkupRequestById: builder.query({
            query: (id) => ({
                url: `/Linkup/GetLinkupRequestById?id=${id}`,
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getLinkupRequestOutputFileById: builder.query({
            query: (id) => ({
                url: `/Linkup/GetLinkupRequestOutputFileById?id=${id}`,
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    })
});

export const {
    useLazyGetAllLinkupRequestQuery,
    useAddLinkupRequestMutation,
    useLazyGetLinkupRequestByIdQuery,
    useLazyGetLinkupRequestOutputFileByIdQuery
} = linkupRequestAPI;

export default linkupRequestAPI;